const canvasSize = {width: 1440, height: 810}

const slotBoard = {
    width: 840,
    height: 671,
    rowCount: 5,
    reelCount: 6,
}


const reels = {
    width: 131,
    height: 653,
    symbolsCount: 5
}

export const desktopConfigs = {
    canvasSize,
    slotBoard,
    reels
}